module.exports = "/images/veil-7.jpg";